import { useLocalStorage } from 'react-use';
// import { AUTOCOMPLETE_STORAGE_KEY as SEARCH_KEY } from '../constants';

export const useSearchAutocompleteHistory = (): [
    string[],
    (val: unknown) => void,
    string,
] => {
    const [value, setValue] = useLocalStorage(
        'search:autocomplete:history',
        '',
        { raw: true },
    );

    const formattedValue =
        value
            ?.split(',')
            ?.map((query: string) => query.trim().toLowerCase())
            ?.filter((trimmedQ: string) => !!trimmedQ) || [];

    return [formattedValue, setValue, value];
};
